import React, { Component } from 'react'
import onClickOutside from 'react-onclickoutside'
import styles from '../Header/styles.module.scss'

class Dropdown extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isOpen: false
    }
  }
  openDropDown = () => {
    if (this.props.onhover) {
      this.setState({
        isOpen: true
      })
    }
  }
  closeDropDown = () => {
    if (this.props.onhover) {
      this.setState({
        isOpen: false
      })
    }
  }
  toggleDropDown = () => {
    this.setState(
      prevState => ({
        isOpen: !prevState.isOpen
      }),
      () => {
        this.props.getDropdownState(this.state.isOpen)
        if (this.state.isOpen) {
          this.props.onPressDropdown()
        }
      }
    )
  }

  handleClickOutside = () => {
    if (this.state.isOpen) {
      this.toggleDropDown()
    }
  }
  render() {
    const { isOpen } = this.state
    const {
      buttonComponent,
      children,
      dropdownStyle,
      className,
      dropdownMainContainerStyles,
      id
    } = this.props
    return (
      <div
        className={styles.dropdownContainer}
        style={dropdownMainContainerStyles}
        id={id}
      >
        <div
          style={{ position: 'relative', width: '100%' }}
          onMouseEnter={this.openDropDown}
          onMouseLeave={this.closeDropDown}
        >
          <div onClick={this.toggleDropDown}>{buttonComponent}</div>
          {isOpen ? (
            <div
              ref={dropdownContainer => {
                this.dropdownContainer = dropdownContainer
              }}
              style={{
                position: 'absolute',
                top: '100%',
                zIndex: 10,
                ...dropdownStyle
              }}
              className={className}
              onClick={this.closeDropDown}
            >
              {children}
            </div>
          ) : null}
        </div>
      </div>
    )
  }
}
Dropdown.defaultProps = {
  onPressDropdown: () => {},
  getDropdownState: () => {}
}

export default onClickOutside(Dropdown)



// WEBPACK FOOTER //
// ./src/components/Dropdown/index.js